export const Main = {
  box: { display: "flex" },
  mainbox: {
    // mt: {xs:'160px',md: '160px'},
    width: { xs: "100%", md: "100%" },
    minHeight: "100vh",
    bgcolor: "#EDE8F5",
  },
};

export const SidebarStyle = {
  box: { display: "flex"},
  appbar: {
    bgcolor: "white",
    "&.MuiAppBar-root": {
      boxShadow: 0,
      position: "relative",
    },
    display: "flex",
    flexDirection: "column",
  },
  listbox: { display: "block", height: "100%" },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    height: "100%",
    width: "100%",
    p: 1.5,
  },
  headerbox: {
    display: "flex",
    alignItems: "center",
    width: "auto",
    gap: 2,
  },
  listitem: { minWidth: 0, color: "white" },
  profile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "gap-1",
    width: "auto",
  },
  // listItem: { display: 'flex', flexDirection: 'column',alignProperty: 'center', mt: 2},
  listItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignProperty: "center",
    mt: 2,
  },
  drawer: {
    width: {xxs: 150, xs: 240, md: 300 },
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: { xs: 240, md: 300 },
      bgcolor: "#1A1A2E",
      color: "white",
      boxShadow: "2px 0px 5px rgba(0,0,0,0.1)",
    },
  },
  drawerIcon: {
    color: "white",
  },
  listItemButton: {
    minHeight: 48,
    px: 2.5,
    "&:hover": {
      bgcolor: "#16213E",
    },
  },
  listItemText: {
    color: "white",
    opacity: 1,
  },
};

export const inputStyles = {
  "& fieldset": { border: "none" }, // Removes border for outlined variant
  backgroundColor: "#fff",
  borderRadius: "4px",
  px: 1,
  py: 0.5,
};

export const DashboardStyle = {
  tabList: { pl: 3, bgcolor: "white" },
  tab: {
    "&.MuiTab-root": {
      color: "black",
      p: 0,
      fontSize: "16px",
      fontWeight: "500",
      textTransform: "none",
      justifyContent: "flex-end",
    },
  },
  tabPanel: { "&.MuiTabPanel-root": { p: 0 } },
  dashboardContainer: {
    bgcolor: "#EDE8F5",
    minHeight: { xs: "55vh", md: "calc(100vh - 260px)" },
    pt: 3,
  },
  buttonCustom: {
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "10px",
    textTransform: "none",
    bgcolor: "white",
    color: "black",
    minWidth: { xs: "100px", md: "109px" },
    mb: 1,
    mr: 1,
  },
  btnbox: {
    display: "flex",
    width: { xs: "18%", xl: "10%" },
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    // alignItems: "center",
    gap: "10px",
    flexDirection: {
      xs: "column-reverse", // for mobile and small screens
      sm: "row", // from small screens and up
    },
  },
  buttonManage: {
    ml: 2,
    textTransform: "none",
    bgcolor: "#95ABEB",
    color: "black",
    justifyContent: "center",
    display: "flex",
    borderRadius: "10px",
    width: { xs: "5px", md: "185px" },
  },
  dateTypography: { fontSize: "12px", ml: 1 },
  accordionContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
  },
  accordionGridItem: {
    flexDirection: { xs: "column", md: "row" },
    xs: 11,
    md: 2.2,
  },
  accordionCard: {
    backgroundColor: "#95ABEB",
    color: "white",
    padding: "10px",
    borderRadius: "8px",
    textAlign: "center",
    cursor: "pointer",
    height: "70px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#8395ae",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "none",
    fontWeight: "bold",
  },
};
export const ManageStyle = {
  modal: { display: "flex", justifyContent: "center", alignItems: "center", m: 2},
  box: { width: "646px", bgcolor: "white", borderRadius: "10px" },
  heading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 2,
    borderBottom: "1px solid black",
  },
  formlabel: {
    color: "black",
    fontSize: "16px",
    "&.Mui-focused": { color: "black" },
  },
  btns: { borderBottom: "1px solid black", pl: 1, pb: 2 },
  typo: { pl: 2, pt: 2 },
};
